export const API_ERROR = "API_PASSWORD_ERROR";
export const RECEIVE_CHANGE_PASSWORD = "RECEIVE_CHANGE_PASSWORD";
export const REQUEST_CHANGE_PASSWORD = "REQUEST_CHANGE_PASSWORD";
